export default __webpack_public_path__ + "static/media/courses-background.0c35e89a.png";